import React, { useState, useEffect } from 'react';
import './magazine.css';

const Revista = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  // URL del flipbook de Heyzine
  const flipbookUrl = "https://heyzine.com/flip-book/1f949d397d.html";

  const handleIframeLoad = () => {
    setIsLoaded(true);
  };

  return (
    <div className="revista-container">
      {/* Efecto de fondo de madera */}
      <div className="wood-background"></div>
      
      {/* Loading State */}
      {!isLoaded && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          <p>Cargando revista...</p>
        </div>
      )}

      {/* Contenedor principal */}
      <div className="viewer-container">
        {/* Marco de la revista */}
        <div className="magazine-frame">
          <div className="frame-border"></div>
          <div className="frame-corner tl"></div>
          <div className="frame-corner tr"></div>
          <div className="frame-corner bl"></div>
          <div className="frame-corner br"></div>
          
          {/* Visor del Flipbook */}
          <div className="flipbook-viewer">
            <div className="flipbook-container">
              <iframe
                src={flipbookUrl}
                className="flipbook-iframe"
                allowFullScreen
                scrolling="no"
                frameBorder="0"
                title="Revista Animada Sigalette"
                onLoad={handleIframeLoad}
                style={{ opacity: isLoaded ? 1 : 0 }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Revista;